const Filters = [
  { label: 'Symbol', name: 'symbol', operator: 'startsWith', type: 'string' },
  { label: 'Gene symbol', name: 'geneSymbol', operator: 'equals', type: 'string' },
  { label: 'Gene NCBI ID', name: 'geneNcbiID', operator: 'startsWith', type: 'string' },
  { label: 'Gene NCBI ID', name: 'gene_ncbi_id', operator: 'equals', type: 'string' },
  { label: 'Gene ENSEMBL ID', name: 'gene_ensembl_id', operator: 'equals', type: 'string' },
  { label: 'Disease prevalence class', name: 'disease_prevalence_class', operator: 'eq', type: 'select' },
  { label: 'Disease prevalence type', name: 'disease_prevalence_type', operator: 'contains', type: 'select' },
  {
    label: 'Disease prevalence geography',
    name: 'disease_prevalence_geo_area',
    operator: 'contains',
    type: 'string',
  },
  { label: 'Clinical significance', name: 'clinical_significance', operator: 'eq', type: 'select' },
  { label: 'Disease inheritance', name: 'disease_inheritance', operator: 'eq', type: 'select' },
  { label: 'Chem molecule type', name: 'chemMoleculeType', operator: 'eq', type: 'select' },
  { label: 'Disease UMLS CUI', name: 'diseaseUMLSCUI', operator: 'equals', type: 'string' },
  { label: 'Pathway name', name: 'pathwayName', operator: 'startsWith', type: 'string' },
  { label: 'Pathway ID', name: 'pathwayID', operator: 'startsWith', type: 'string' },
  { label: 'Score', name: 'score', operator: 'eq', type: 'number' },
  { label: 'EL', name: 'EL', operator: 'eq', type: 'select' },
  { label: 'EI', name: 'EI', operator: 'eq', type: 'number' },
  { label: 'Gene NCBI type', name: 'geneNcbiType', operator: 'eq', type: 'select' },
  { label: 'NCTs', name: 'numCTs', operator: 'eq', type: 'number' },
  {
    label: 'PMID supporting association',
    name: 'numPMIDsupportingAssociation',
    operator: 'eq',
    type: 'number',
    integer: true,
  },
  {
    label: 'DBSNP supporting association',
    name: 'numDBSNPsupportingAssociation',
    operator: 'eq',
    type: 'number',
    integer: true,
  },
  { label: 'Year initial', name: 'yearInitial', operator: 'eq', type: 'number', integer: true },
  { label: 'Year final', name: 'yearFinal', operator: 'eq', type: 'number', integer: true },
  { label: 'Disease name', name: 'diseaseName', operator: 'startsWith', type: 'string' },
  { label: 'Gene description', name: 'geneDescription', operator: 'equals', type: 'string', dir: '' },
  { label: 'Gene protein class names', name: 'geneProteinClassNames', operator: 'eq', type: 'select' },
  {
    label: '# diseases associated to gene',
    name: 'numDiseasesAssociatedToGene',
    operator: 'eq',
    type: 'number',
    integer: true,
  },
  {
    label: '# variants associated to gene',
    name: 'numVariantsAssociatedToGene',
    operator: 'eq',
    type: 'number',
    integer: true,
  },
  { label: 'Gene DSI', name: 'geneDSI', operator: 'eq', type: 'number' },
  { label: 'Gene DPI', name: 'geneDPI', operator: 'eq', type: 'number' },
  { label: 'Gene pLI', name: 'genepLI', operator: 'eq', type: 'number' },
  { label: 'Gene ENSEMBL IDs', name: 'geneEnsemblIDs', operator: 'equals', type: 'string', disable: true }, // Not working in legacy
  { label: 'Disease type', name: 'diseaseType', operator: 'eq', type: 'select' },
  { label: 'MSH', name: 'diseaseClassName_MSH', operator: 'eq', type: 'select' },
  { label: 'UMLS', name: 'diseaseClassName_UMLS', operator: 'eq', type: 'select' },
  { label: 'DO', name: 'diseaseClassName_DO', operator: 'eq', type: 'select' },
  { label: 'HPO', name: 'diseaseClassName_HPO', operator: 'eq', type: 'select' },
  {
    label: '# variants associated to gene',
    name: 'numGenesAssociatedToDisease',
    operator: 'eq',
    type: 'number',
    integer: true,
  },
  {
    label: '# variants associated to disease',
    name: 'numVariantsAssociatedToDisease',
    operator: 'eq',
    type: 'number',
    integer: true,
  },
  { label: 'Gene protein Str IDs', name: 'geneProteinStrIDs', operator: 'equals', type: 'string' },
  { label: 'Disease1 name', name: 'disease1_Name', operator: 'equals', type: 'string' },
  { label: 'Disease2 name', name: 'disease2_Name', operator: 'equals', type: 'string' },
  { label: 'nGenes disease ID-1', name: 'ngenes_diseaseID_1', operator: 'eq', type: 'number' },
  { label: 'nVariants disease ID-1', name: 'nvariants_diseaseID_1', operator: 'eq', type: 'number' },
  { label: 'Disease1 DO', name: 'disease1ClassName_DO', operator: 'eq', type: 'select' },
  { label: 'Disease1 HPO', name: 'disease1ClassName_HPO', operator: 'eq', type: 'select' },
  { label: 'Disease1 MSH', name: 'disease1ClassName_MSH', operator: 'eq', type: 'select' },
  { label: 'Disease1 UMLS', name: 'disease1ClassName_UMLS', operator: 'eq', type: 'select' },
  { label: 'Disease1 type', name: 'disease1_Type', operator: 'eq', type: 'select' },
  { label: 'Disease2 DO', name: 'disease2ClassName_DO', operator: 'eq', type: 'select' },
  { label: 'Disease2 HPO', name: 'disease2ClassName_HPO', operator: 'eq', type: 'select' },
  { label: 'Disease2 MSH', name: 'disease2ClassName_MSH', operator: 'eq', type: 'select' },
  { label: 'Disease2 UMLS', name: 'disease2ClassName_UMLS', operator: 'eq', type: 'select' },
  { label: 'Disease1 UMLS CUI', name: 'disease1_UMLSCUI', operator: 'ep', type: 'number' },
  { label: 'Disease2 UMLS CUI', name: 'disease2_UMLSCUI', operator: 'ep', type: 'number' },
  { label: 'Disease2 type', name: 'disease2_Type', operator: 'eq', type: 'select' },
  { label: 'nGenes disease ID-2', name: 'ngenes_diseaseID_2', operator: 'eq', type: 'number' },
  { label: 'nVariants disease ID-2', name: 'nvariants_diseaseID_2', operator: 'eq', type: 'number' },
  { label: 'Shared genes', name: 'shared_genes', operator: 'eq', type: 'number' },
  { label: 'Jaccard genes', name: 'jaccard_genes', operator: 'eq', type: 'number' },
  { label: 'pValue jaccard genes', name: 'pvalue_jaccard_genes', operator: 'eq', type: 'number' },
  { label: 'Shared variants', name: 'shared_variants', operator: 'eq', type: 'number' },
  { label: 'Jaccard variants', name: 'jaccard_variants', operator: 'eq', type: 'number' },
  { label: 'pValue jaccard variants', name: 'pvalue_jaccard_variants', operator: 'eq', type: 'number' },
  { label: 'Sokal', name: 'sokal', operator: 'eq', type: 'number' },
  { label: 'DDA relation', name: 'ddaRelation', operator: 'eq', type: 'select' },
  { label: 'Name', name: 'name', operator: 'startsWith', type: 'string' },
  { label: 'Type', name: 'type', operator: 'eq', type: 'select' },
  { label: 'NCT ID', name: 'nct_id', operator: 'startsWith', type: 'string' },
  { label: 'First reference', name: 'firstRef', operator: 'eq', type: 'number' },
  { label: 'Last reference', name: 'lastRef', operator: 'eq', type: 'number' },
  { label: '# publications', name: 'numPublications', operator: 'eq', type: 'number', integer: true },
  { label: '# publications GDA', name: 'numPublications_GDA', operator: 'eq', type: 'number', integer: true },
  { label: '# publications VDA', name: 'numPublications_VDA', operator: 'eq', type: 'number', integer: true },
  { label: 'Chem ID', name: 'chemID', operator: 'startsWith', type: 'string' },
  { label: 'Chem pref name', name: 'chemPrefName', operator: 'startsWith', type: 'string' },
  {
    label: 'Chem # publications',
    name: 'chemNumPublications',
    operator: 'eq',
    type: 'number',
    integer: true,
  },
  { label: 'Chem # GDAs', name: 'chemNumGDAs', operator: 'eq', type: 'number', integer: true },
  {
    label: 'Chem # publications GDAs',
    name: 'chemNumPublicationsGDAs',
    operator: 'eq',
    type: 'number',
    integer: true,
  },
  { label: 'Chem # VDAs', name: 'chemNumVDAs', operator: 'eq', type: 'number', integer: true },
  {
    label: 'Chem # publications VDAs',
    name: 'chemNumPublicationsVDAs',
    operator: 'eq',
    type: 'number',
    integer: true,
  },
  { label: 'Association type', name: 'associationType', operator: 'eq', type: 'select' },
  { label: 'Sentence HTML', name: 'sentenceHTML', operator: 'equals', type: 'string' },
  { label: 'Ancestry name', name: 'ancestry_name', operator: 'eq', type: 'select' },
  { label: 'Beta', name: 'beta', operator: 'eq', type: 'number' },
  { label: 'Gender', name: 'gender', operator: 'eq', type: 'select' },
  { label: 'Odds ratio', name: 'odds_ratio', operator: 'eq', type: 'number' },
  { label: 'PMID', name: 'pmid', operator: 'eq', type: 'number' }, //todo: int?
  { label: 'PM year', name: 'pmYear', operator: 'eq', type: 'number', integer: true },
  { label: 'Journal abbrv', name: 'journal_abbrv', operator: 'startsWith', type: 'string' },
  { label: 'Chem IDs', name: 'chemIDs', operator: 'startsWith', type: 'string' },
  { label: 'Variant Str ID', name: 'variantStrID', operator: 'startsWith', type: 'string' },
  { label: 'Gene NCBI IDs', name: 'geneNcbiIDs', operator: 'startsWith', type: 'string' },
  { label: 'Variant DSI', name: 'variantDSI', operator: 'eq', type: 'number' },
  { label: 'Variant DPI', name: 'variantDPI', operator: 'eq', type: 'number' },
  { label: 'Most severe consequences', name: 'mostSevereConsequences', operator: 'eq', type: 'select' },
  {
    label: '# diseases associated to variant',
    name: 'numDiseasesAssociatedToVariant',
    operator: 'eq',
    type: 'number',
    integer: true,
  },
  { label: 'Str ID', name: 'strID', operator: 'startsWith', type: 'string' },
  { label: 'DSI', name: 'DSI', operator: 'eq', type: 'number' },
  { label: 'Chromosome', name: 'chromosome', operator: 'eq', type: 'string' },
  { label: 'DPI', name: 'DPI', operator: 'eq', type: 'number' },
  { label: 'DBSNP class', name: 'DBSNPclass', operator: 'eq', type: 'select' },
  { label: 'Alleles', name: 'alleles', operator: 'equals', type: 'string', disable: true },
  { label: 'Exome', name: 'exome', operator: 'eq', type: 'number', disable: false },
  { label: 'Genome', name: 'genome', operator: 'eq', type: 'number', disable: false },
  { label: 'Gof lof', name: 'gof_lof', operator: 'eq', type: 'select' },
  { label: 'Risk allele', name: 'riskAllele', operator: 'eq', type: 'select' },
  { label: 'Allele freq genome', name: 'alleleFreqGenome', operator: 'eq', type: 'number', disable: true },
  {
    label: 'Chem # publications GDA',
    name: 'chemNumPublicationsGDA',
    operator: 'eq',
    type: 'number',
    integer: true,
  },
  {
    label: 'Chem # publications VDA',
    name: 'chemNumPublicationsVDA',
    operator: 'eq',
    type: 'number',
    integer: true,
  },
  { label: 'Chems in sentence', name: 'chemsInSentence', operator: 'startsWith', type: 'string' },
  { label: 'Coord', name: 'coord', operator: 'eq', type: 'number', disable: true },
  { label: 'Description', name: 'description', operator: 'equals', type: 'string' },
  { label: 'Polyphen score', name: 'polyphen_score', operator: 'eq', type: 'number' },
  { label: 'Sift score', name: 'sift_score', operator: 'eq', type: 'number' },
  { label: 'NCBI type', name: 'ncbi_type', operator: 'eq', type: 'select' },
  { label: 'NCBI ID', name: 'ncbiID', operator: 'startsWith', type: 'string' },
  {
    label: '# PMIDs with chems included in evidence',
    name: 'numberPmidsWithChemsIncludedInEvidence',
    operator: 'eq',
    type: 'number',
    integer: true,
    disable: true,
  },
  {
    label: '# CTs with chems included in evidence',
    name: 'numberNCTSWithChemsIncludedInEvidence',
    operator: 'eq',
    type: 'number',
    integer: true,
    disable: true,
  },
  { label: 'PLI', name: 'PLI', operator: 'eq', type: 'number' },
  { label: 'Protein class IDs', name: 'proteinClassIDs', operator: 'eq', type: 'select' },
  { label: 'Protein IDs', name: 'proteinIDs', operator: 'eq', type: 'string', disable: true }, // filtering not supported by backend, should be remapped to geneProteinStrIDs
  { label: 'pValue', name: 'pValue', operator: 'eq', type: 'number', disable: true }, // migrated disabled state from disgenetplus
  { label: 'Source', name: 'source', operator: 'eq', type: 'select' },
  { label: 'Chemical effect', name: 'chemical_effect', operator: 'eq', type: 'select' },
  { label: 'Reference', name: 'reference', operator: 'equals', type: 'string' },
  { label: 'Reference type', name: 'reference_type', operator: 'eq', type: 'select' },
  { label: 'Chebi', name: 'chebi', operator: 'eq', type: 'string' },
  { label: 'Pubchem', name: 'pubchem', operator: 'eq', type: 'string' },
  { label: 'Drugbank', name: 'drugbank', operator: 'eq', type: 'string' },
  { label: 'MESH', name: 'mesh', operator: 'eq', type: 'string' },
  {
    label: '# chems included in evidence',
    name: 'numberChemsIncludedInEvidence',
    operator: 'eq',
    type: 'number',
    integer: true,
  },
  { label: 'Polarity', name: 'association', operator: 'eq', type: 'select' },
  { label: 'Citation Count', name: 'citation_count', operator: 'eq', type: 'number', integer: true },
  { label: 'N Chemicals', name: 'numChemicals', operator: 'eq', type: 'number', integer: true },
  { label: 'My Score', name: 'sourceScore', operator: 'eq', type: 'number' },
];

export default Filters;
